import { Html5State } from './state';
import { Html5Page } from './typings';

export function getCurrentCreativesState(html5State: Html5State) {
    const { page } = html5State;
    let result;
    if (page === Html5Page.ACTIVE) {
        result = html5State.activeCreatives;
    } else if (page === Html5Page.ARCHIVE) {
        result = html5State.archiveCreatives;
    } else {
        throw new Error(`Page ${page} is not supported`);
    }
    return result;
}
